export default "__VITE_ASSET__6be79cc4__"